import React from 'react'
import PropTypes from 'prop-types'

import Spinner from 'lib/tags/spinner'

const SubmitButton = ({
  style,
  isSubmitting,
  isButtonHaveDisabledStyle,
  children,
  className,
  spinnerClass,
  onClick,
  type = 'button',
  disabled,
  ...other
}) => {
  return (
    <button
      type={type}
      className={`button${isSubmitting ? ' is-submitting' : ''}${isButtonHaveDisabledStyle ? ' disabled' : ''}${
        className ? ' ' + className : ''
      }`}
      style={style}
      disabled={disabled}
      key={isSubmitting ? 'submitting' : 'not-submitting'}
      {...(isSubmitting ? {} : { onClick })}
      {...other}
    >
      {isSubmitting ? <Spinner color={spinnerClass || 'white'} /> : children}
    </button>
  )
}

SubmitButton.propTypes = {
  isSubmitting: PropTypes.bool,
  isButtonHaveDisabledStyle: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  type: PropTypes.string,
  spinnerClass: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.node,
  style: PropTypes.object
}

export default SubmitButton
